module.exports = __webpack_public_path__ + "img/ArrRight.17017187.svg";